<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full resto_logo" src="img/logo.png" />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" v-b-tooltip.hover title="App Menu On/Off" />
      <span style="padding-left: 23px">
        <span :class="timeServer != now ? 'bg-danger p-2' : 'p-2'">{{
            timeServer | moment("dddd, DD MMMM YYYY")
        }}</span>
      </span>
      <b-navbar-nav class="ml-auto">
        <div class="d-sm-down-none pl-2 title font-weight-bold">
          <b-link @click="selectCompany">{{ user.company }}</b-link>
        </div>
        <div class="d-sm-down-none pl-2 title font-weight-bold">
          {{ user.customer_nm }}
        </div>
        <b-tasknotif />
        <b-account @profile="profile" />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav style="font-size: smaller" :navItems="navItems"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <div class="container-fluid mt-1">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <AppFooter>
      <marquee-text :repeat="3" v-if="availPromo">
        <h5 class="text-primary ml-5 mr-5">{{ availPromo }}</h5>
      </marquee-text>
    </AppFooter>
    <b-alert v-model="showTop" class="position-fixed fixed-top m-0 rounded-0" style="z-index: 2000" variant="warning"
      dismissible>
      {{ webloannotification }}
    </b-alert>
    <b-modal v-model="lkuCompanyShow" size="lg" header-bg-variant="danger" :hide-footer="true" title="Switch Company"
      :centered="true">
      <lku-company @click="onSelectLkuCompany"></lku-company>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.app-header {
  .resto_logo {
    height: 50px;
  }
}

.header-dropdown {
  margin-right: 20px;
}
</style>

<script>
import moment from "moment";

import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  AsideToggler,
  Footer as AppFooter,
  // Breadcrumb
} from "@coreui/vue";
import MarqueeText from "vue-marquee-text-component";
import Aside from "../components/aside";
import Dropdown from "../components/dropdown";
import bTasknotif from "../components/tasknotify";
import bAccount from "../components/account";
import menus from "../data/menus.json";
import dim from "../apis/dim";
import lkuCompany from "../views/lookup/lkuCompanyuser";
import auth from "../apis/auth.js";

export default {
  components: {
    AppHeader,
    AppSidebar,
    AppFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarFooter,
    SidebarForm,
    SidebarMinimizer,
    SidebarNav,
    AsideToggler,
    Dropdown,
    bTasknotif,
    bAccount,
    MarqueeText,
    lkuCompany,
  },
  data() {
    return {
      navItems: [
        {
          "name": "Home",
          "url": "/home",
          "icon": "fa fa-home"
        }
      ],
      showTop: false,
      msg: "",
      lkuCompanyShow: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    name() {
      return this.$route.name;
    },
    badgePelunasan() {
      if (this.$store.state.dashboard.pelunasanDash) {
        return this.$store.state.dashboard.pelunasanDash.count;
      } else {
        return 0;
      }
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
    availPromo() {
      return this.$store.state.promocsv || "";
    },
    timeServer() {
      return this.$store.state.timeServer;
    },
    now() {
      return moment(new Date()).format("YYYY-MM-DD");
    },
    webloannotification() {
      return this.$store.state.webloannotification;
    },
  },
  watch: {
    // //   $route(to, from) {
    // //     const { meta } = to;
    // //     if (meta && meta.hideBreadcrumb) {
    // //       this.showBreadcrumb = 0;
    // //     } else {
    // //       this.showBreadcrumb = 1;
    // //     }
    // //   }
    webloannotification(newValue, oldValue) {
      console.log("newValue", newValue);
      if (newValue) {
        this.showTop = true;
      }
    },
  },
  sockets: {
    connect: function () {
      console.log("socket connected");
    },
    switchcompany: function (baru) {
      if (
        this.user.user_id === baru.user_id &&
        this.user.compcode != baru.compcode
      ) {
        this.user.compcode = baru.compcode;
        this.user.company = baru.company;
        this.user.compaddr = `${baru.compaddr1} ${baru.compaddr2 || ""} ${baru.compaddr3 || ""
          }`;
        this.user.compwebsite = baru.compwebsite;
        this.user.compcolor = baru.compcolor;
        this.user.cashinflowNo = baru.cashinflowNo;
        this.user.cashinflowNm = baru.cashinflowNm;
        this.user.use_wfservice = baru.use_wfservice;
        this.user.use_procure = baru.use_procure;
        this.user.holding = baru.holding;
        this.user.matauang = baru.matauang;
        this.user.tglaktif = baru.tglaktif;
        this.user.tglkoran = baru.tglkoran;
        this.user.akhirbln = baru.akhirbln;
        this.user.awalbln = baru.awalbln;

        this.refreshCompany(baru);
      }
    },
    userNotify(value) {
      const { title, message } = value;
      // Let's check if the browser supports notifications
      let options = {
        body: message,
        dir: "rtl", //auto, ltr or rtl
        icon: "/logo/logo_blue.png",
        sound: "/notiftone/moonless-591.mp3",
        requireInteraction: true,
      };

      if (!("Notification" in window)) {
        alert("This browser does not support desktop notification");
      }
      // Let's check if the user is okay to get some notification
      else if (Notification.permission === "granted") {
        // If it's okay let's create a notification

        var notification = new Notification(title, options);

        setTimeout(notification.close.bind(notification), 360000);
      }
      // Otherwise, we need to ask the user for permission
      // Note, Chrome does not implement the permission static property
      // So we have to check for NOT 'denied' instead of 'default'
      else if (Notification.permission !== "denied") {
        Notification.requestPermission(function (permission) {
          // Whatever the user answers, we make sure we store the information
          if (!("permission" in Notification)) {
            Notification.permission = permission;
          }
          // If the user is okay, let's create a notification
          if (permission === "granted") {
            var notification = new Notification(title, options);

            setTimeout(notification.close.bind(notification), 360000);
          }
        });
      }
      // At last, if the user already denied any notification, and you
      // want to be respectful there is no need to bother them anymore.
    },
    notifbadge(value) {
      const {dataNotifMsg} = value;
      this.$store.commit("notifbadge", dataNotifMsg);
    },
    
  },

  async created() {
    let _menus = [{
      "name": "Home",
      "url": "/home",
      "icon": "fa fa-home"
    },
    {
        "name": "Dashboard",
        "url": "/dashboard",
        "icon": "fa fa-dashboard",
        "children":[
           {
                "name": "Fund",
                "url": "/dashboard/fund",
                "routename": "paylater.dashboard.fund"
            }
        ]
    },
    // {
    //   "name": "Dashboard",
    //   "url": "/dashboard",
    //   "icon": "fa fa-dashboard"
    // }
  ];
    // eslint-disable-next-line vue/no-async-in-computed-properties
    let modulname= process.env.VUE_APP_MODUL;
    let dtAuth = await auth.menuuser({ modulname, 'username': this.$store.state.user.username });
    if (dtAuth) {
      for (let idx = 0; idx < menus.length; idx++) {
        let menu = menus[idx];
        let menuAuth;
        let routename_ = menu.routename;
        let havechildren;
        if ((menu.children || []).length > 0) {
          havechildren = true;
        }
        if (havechildren) {
          let mnchild = menu.children;
          let newChild = [];
          let newMenuhaveChild = menu;
          newMenuhaveChild.children = [];
          Promise.all(
            mnchild.map(async (submenu, subidx) => {
              let subroutename_ = submenu.routename;
              if ((subroutename_ || '') !== '') {
                menuAuth = dtAuth.find(x => x.name == `app.${process.env.VUE_APP_MODUL}.${subroutename_}`);                
                if (menuAuth) {
                  if ((menuAuth.ALL || '') != '') {
                    // mnchild.splice(idx,1);
                    newChild.push(submenu);
                  }
                }
              }
            })
          );
          if (newChild.length > 0) {
            newMenuhaveChild.children = newChild;
            _menus.push(newMenuhaveChild);
          }

        } else {
          if ((routename_ || '') !== '') {
            menuAuth = dtAuth.find(x => x.name == `app.${process.env.VUE_APP_MODUL}.${routename_}`);
            if (menuAuth) {
              if ((menuAuth.ALL || '') != '') {
                // _menus.splice(idx,1);
                _menus.push(menu);
              }
            }
          }
        }
      }
    }

    console.log('_menus',_menus)
    this.navItems = _menus;
    const this_ = this;
    _menus.map((x, idx) => {
      if (x.name.includes("trans.") && x.name) {
        this_.navItems[idx].name = this_.$t(
          x.name.replace("trans.", "").toString()
        );
      }
    });
    this.$socket.emit("user_join", this.$store.state.user);
    // if (!this.user.outletid) {
    //   this.$router.push({ name: "page.login" });
    // }
    const { meta } = this.$route;
    if (meta && meta.hideBreadcrumb) {
      this.showBreadcrumb = 0;
    } else {
      this.showBreadcrumb = 1;
    }
    const dims = await dim.dimsetup();
    this.$store.commit("dimension", dims);
    if (this.$store.state.dashboard.pelunasanDash) {
      const getIdxPelunasan = menus.findIndex(
        (x) => x.name == "Daftar Pelunasan"
      );
      if (this.navItems[getIdxPelunasan]) {
        this.navItems[getIdxPelunasan].children[1].badge.text =
          this.$store.state.dashboard.pelunasanDash.count;
      }
    }
    this.check();
  },
  methods: {
    logout() {
      boogr.logout();
    },
    profile() {
      this.$router.push("/profile");
    },
    myapp() {
      location.href = process.env.VUE_APP_MYAPP;
    },
    selectCompany() {
      // console.log('selectCompany ke click di admin')
      this.lkuCompanyShow = true;
    },
    onSelectLkuCompany: async function (_selected) {
      if (this.user.compcode != _selected.compcode) {
        this.user.compcode = _selected.compcode;
        this.user.company = _selected.company;
        this.user.compaddr = `${_selected.compaddr1} ${_selected.compaddr2 || ""
          } ${_selected.compaddr3 || ""}`;
        this.user.compwebsite = _selected.compwebsite;
        this.user.compcolor = _selected.compcolor;
        this.user.cashinflowNo = _selected.cashinflowNo;
        this.user.cashinflowNm = _selected.cashinflowNm;
        this.user.use_wfservice = _selected.use_wfservice;
        this.user.use_procure = _selected.use_procure;
        this.user.holding = _selected.holding;
        this.user.matauang = _selected.matauang;
        this.user.tglaktif = _selected.tglaktif;
        this.user.tglkoran = _selected.tglkoran;
        this.user.akhirbln = _selected.akhirbln;
        this.user.awalbln = _selected.awalbln;

        console.log("user ", this.user);
        const baru = {};
        for (var key in this.user) {
          baru[key] = this.user[key];
        }
        await auth.updateLastCompany(baru);
        // this.$store.commit('user', baru);
        // this.$socket.emit('notificationupdate', {key:'notifycount', user : baru});
        // const dims = await dim.dimsetup() ;
        // this.$store.commit("dimension", dims);
        // if (this.$route.name != 'app.modules') {
        //   this.$router.push("home");
        // }
        this.refreshCompany(baru);
      }
      this.lkuCompanyShow = false;
    },
    refreshCompany: async function (baru) {
      this.$store.commit("user", baru);
      this.$socket.emit("notificationupdate", {
        key: "notifycount",
        user: baru,
      });
      const dims = await dim.dimsetup();
      this.$store.commit("dimension", dims);
      this.bannerStyle = {};
      if (this.user.compcolor) {
        this.bannerStyle = { backgroundColor: this.user.compcolor };
      }
      window.location.reload();
      // if (this.$route.name != 'app.modules') {
      //   // this.$router.push({ name: "app.modules" });
      //   this.$router.push("home");
      //   // router.push("home");
      // }
    },
    check() {
      switch (Notification.permission) {
        // user previously denied permission
        case "denied":
          window.alert(
            "You denied permission. Please change your browser settings for this page to view notifications"
          );
        // user already has accepted permission
        // eslint-disable-next-line no-fallthrough
        case "granted":
          // new Notification(
          //   "Already Granted",
          //   "You have already granted permission"
          // );
          // window.alert(
          //   "You have already granted permission-Already Granted"
          // );
          console.log("You have already granted permission - Notification Already Granted");
          break;
        // should be "default", but catch all anyways
        default:
          Notification.requestPermission((status) => {
            if (status === "granted")
              Notification(
                "Permission Granted",
                "Thank you for granting permission"
              );
          });
      }
    },
  },
};
</script>
